export default {"src":"/_next/static/media/Hernias.17cfb1e7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};